import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { store } from '../src/redux/store'

const currentLanguage = store.getState().profileData.language;
const resources = {
    en: {
        translation: {
            login: "Login",
            register: 'Register',
            uniquekey: 'Unique key',
            keyinfo: 'What is this?',
            name: 'Name',
            lastname: 'Last name',
            keydes: 'This is a one-time code that you will receive from your school staff. It will allow you to create an account.',
            firstTime: "First time?",
            signup: "Sign up",
            copyright: '© 2025 Zubrus. All rights reserved.',
            email: 'Email',
            password: 'Password',
            confirmmsg: 'We will send a confirmation email to your email address.',
            agree: 'I agree with',
            rules: 'By the rules',
            and: 'and',
            policy: 'Privacy Policy',
            confirmemail: 'Confirm your email address',
            emailmsg: 'We have sent a confirmation to your email address {{email}}. Confirmation is required so that if you accidentally forget your password, it is easy to recover it.',
            back: "Go to Zubrus",
            profile: 'Profile',
            creator: 'Want to become a creator?',
            creatordes: 'Create your own decks and materials.',
            want: 'I want',
            Personaldata: 'Personal data',
            changepassword: 'Change password',
            changelan: "Change Language",
            logout: "Log out",
            becomecreator: "I want to become a creator.",
            becomecreatorh1: 'Want to create your own Zubrus material?',
            becomecreatorh2: 'Perhaps you would like not only your students but also other children in Lithuania to achieve them?',
            becomecreatorh3: 'Or maybe you would like to work with Zubrus and earn money?,',
            becomecreatorh4: 'Register by simply clicking the button and we will contact you!',
            signup2: 'Sign up!',
            registered: 'You have registered!',
            newsoon: 'We will be back with news soon.',
            myclasses: 'My classes',
            createclass: 'Create a class',
            picture: 'Picture',
            student: 'students',
            teacher: 'teachers',
            createfirstclass: "Create your first class.",
            class: 'Classes',
            zubroteka: 'Deck',
            workshop: 'Workshops',
            september: "September 2024",
            menuItems: {
                classes: "Classes",
                zubroteka: "Deck",
                workshops: "Workshops",
                Contentcreator: 'Content-creator',
                admin: 'Admin'
            },
            adminmenu: {
                userlist: 'UserList',
                classlist: 'classList',
                parentslist: 'parentsList',
                teacherlist: 'teacherList',
                creatorList: 'creatorList',
                payments: 'Payments',
                service: 'Service'
            },
            tabs: {
                overview: "Overview",
                material: "Material",
                people: "People"
            },
            filter: {
                popularity: "By popularity",
                newest: "By newest",
                recently_watched: "By recently watched"
            },
            average: 'Average',
            activity: 'activity',
            result: 'result',
            mostactive: 'Most active',
            passive: 'The most passive',
            best: "The best",
            worst: 'Worst',
            deckspopularity: 'Decks by popularity',
            deckscore: "Decks by average score",
            edit: 'Edit',
            add: "Add",
            castle: 'Castle',
            folder: 'Folder',
            editmode: "Editing mode",
            adjust: 'Move and rearrange elements, delete unnecessary blocks.',
            allsee: 'Everyone can see',
            nosee: 'No one sees',
            Optional: 'Optional',
            whosee: 'Who sees',
            uncheck: 'Uncheck all',
            question:"Question",
            questions: 'Questions',
            about: 'About the   ',
            Statistics: "Statistics",
            general: 'General',
            all: 'All',
            people: 'People',
            search: 'Search',
            Performance: 'Performance',
            remove: 'Remove',
            fromclass: 'from the class?',
            dltmsg: 'A removed person will no longer be able to see your class content and their statistics will disappear.',
            cancel: 'Cancel',
            selectSchool: 'Select School',
            noSchoolsFound: 'No Schools Found',
            continue: 'Continue',
            pleaseSelectSchool: 'Please select a school to continue',
            failedToFetchSchools: 'Failed to fetch school information',
            schoolSelectionRequired: 'School selection is required to continue. Please contact your administrator.',
            noSchoolsMessage: 'You don\'t have access to any schools at the moment.',
            singleSchoolAutoSelected: 'This school has been automatically selected for you.',
            catalog: 'Catalog',
            Favorites: 'Favorites',
            useit: 'I already use it.',
            Alldisciplines: 'All disciplines',
            allages: 'For all ages',
            Allauthors: 'All authors',
            Bypopularity: 'By popularity',
            detail: 'In Detail',
            answer: 'Answer',
            answers: 'Answers',
            Prompter: 'Prompter',
            feedback: 'Feedback to the developer',
            answerType: "Answer Type",
            answerTypeInput: "Input",
            answerTypeMemory: "Memory",
            answerTypeTest: "Test",
            complexity: "Complexity",
            complexityVeryEasy: '1 Very Easy',
            complexityEasy: '2 Easy',
            complexityMedium: '3 Medium',
            complexityHard: '4 Hard',
            complexityVeryHard: '5 Very Hard',
            cardName: 'Card Name',
            addCard: 'Add Card',
            editCard: 'Edit Card',
            editDeck: 'Edit Deck',
            addAnswer: 'Add Answer',
            newQuestion: 'New Question',
            addHint: 'Add Prompter',
            characters: 'characters',
            clickToAddImage: 'Click to add image',
            addMore: 'Add more',
            addImage: 'Add image',
            addAudio: 'Add audio',
            addText: 'Add text',
            aiAudioSection: 'AI / Audio (optional)',
            aiAudioHelper: 'Playback priority: audio URL → TTS from AI text → text from card parts.',
            ttsTextOptional: 'TTS text (optional)',
            ttsTextPlaceholder: 'Text used for TTS if no audio URL',
            audioUrlOptional: 'Audio URL (optional)',
            fillFromText: 'Fill from text',
            uploadAudio: 'Upload',
            strictCheck: 'Strict check',
            move: 'Move',
            deckUpdatedSuccess: 'Card updated successfully',
            deckCardAddedSuccess: 'Card added successfully',
            enterText: 'Enter text...',
            inputHint: 'Input hint',
            inputHintPlaceholder: 'Hint for how to answer...',
            addInputHint: 'Add input hint',
            clickToAdd: 'Click to add',
            uploadImages: 'Upload Images',
            uploadImage: 'Upload Image',
            clickToUploadImages: 'Click to upload images',
            uploading: 'Uploading...',
            uploadImageCount: 'Upload {{count}} Image(s)',
            uploadFiles: 'Upload Files',
            uploadImagesAndAudio: 'Images & Audio',
            clickToUploadFiles: 'Click to Upload Files',
            supportsImagesAndAudio: 'Supports Images & Audio Files',
            selectedFiles: 'Selected Files',
            uploadFileCount: 'Upload {{count}} File(s)',
            Send: 'Send',
            assignToDeck: 'Assign to Deck',
            assignCardToAnotherDeck: 'Assign Card',
            searchDecks: 'Search decks...',
            searchCards: 'Search cards...',
            selectAtLeastOneDeck: 'Please select at least one deck',
            cardAssignedSuccess: 'Card assigned to {{count}} deck(s) successfully',
            cardAssignedError: 'Failed to assign to {{count}} deck(s)',
            cardsAssignedSuccess: '{{count}} card(s) assigned successfully',
            selected: 'selected',
            selectDecks: 'Select decks to assign',
            selectACard: 'Select a card',
            selectCardToAssign: 'Select Card to Assign',
            selectCardsToAssign: 'Select Cards to Assign',
            selectCards: 'Select cards',
            selectTargetDecks: 'Select Target Decks',
            step1of2: 'Step 1 of 2',
            noCardsFound: 'No cards found',
            noCardsInDeck: 'No cards in this deck',
            noCardsToAssign: 'No cards available to assign. Please add cards first.',
            select: 'Select',
            selectAll: 'Select All',
            deselectAll: 'Deselect All',
            cardSelected: 'card selected',
            cardsSelected: 'cards selected',
            decksSelected: 'deck(s) selected',
            selectDeck: 'Select Deck',
            importCard: 'Import Card',
            cardView: 'Cards',
            listView: 'List',
            moveCardUp: 'Move up',
            moveCardDown: 'Move down',
            dragToReorder: 'Drag to change order',
            savingOrder: 'Saving order...',
            cardOrderSaved: 'Card order saved',
            cardOrderFailed: 'Failed to save card order',
            cardOrderLoginRequired: 'Log in to save the card order',
            myDecks: 'My Decks',
            allDecks: 'All Decks',
            importCardsFromDeck: 'Import Cards from Deck',
            selectCardsToImport: 'Select Cards to Import',
            selectSourceDeck: 'Choose a deck to import cards from',
            chooseSourceDeck: 'Choose a source deck',
            selectCardsToImportHint: 'Select cards to import',
            importing: 'Importing...',
            import: 'Import',
            cardsImportedSuccess: 'Cards imported successfully',
            deckDeletedSuccess: 'Card removed successfully',
            deckIdMissing: 'Deck ID not found',
            fixValidationErrors: 'Please fix validation errors before importing',
            multipleChoice: 'Multiple Choice',
            answerOption: 'Answer option',
            markAsCorrect: 'Mark as correct',
            markAsWrong: 'Mark as wrong',
            correctAnswer: '✓ Correct answer',
            wrongAnswer: 'Wrong answer',
            addAnswerOption: 'Add answer option',
            testAnswerInfo: 'Click on the letter/checkmark to mark the correct answer. At least 2 options required, 1 must be correct.',
            correct: 'correct',
            total: 'total',
            mark: 'Mark',
            markPlaceholder: 'e.g. Exam, Quiz',
            markHelperText: 'Displayed on top of the card',
            mainSubjectPlaceholder: 'e.g. Math, Science',
            subject: 'Subject',
            gradeLabel: 'Grade',
            schoolGrades: 'School Grades',
            schoolGradesPlaceholder: 'e.g. 5, 6-8, 10-12',
            schoolGradesHelperText: 'Optional. Specify target grades.',
            region: 'Region',
            selectRegion: 'Select Region',
            next: 'Next',
            assign: 'Assign',
            assigning: 'Assigning...',
            noDecksFound: 'No decks found',
            noOtherDecks: 'No other decks available',
            cards: 'cards',
            deckName: 'Deck Name',
            status: 'Status',
            authorName: 'Author Name',
            createdBy: 'Created By',
            language: 'Language',
            countries: 'Countries',
            creationDate: 'Creation Date',
            published: 'PUBLISHED',
            deckworkshop: 'Deck Workshop',
            creatdeck: 'Create a deck',
            validatingFile: 'Validating File...',
            pleaseWaitProcessing: 'Please wait while we process your deck file',
            processingAndAdding: 'Importing...',
            addDeck: 'Import',
            verifyAgain: 'Verify Again',
            askAI: 'Ask AI',
            askingAI: 'Asking AI...',
            DeckInformation: 'Deck Information',
            DeckSummary: 'Deck Summary',
            DeckWarnings: 'Deck Warnings',
            DeckErrors: 'Deck Errors',
            Draft: 'Draft',
            Published: 'Published',
            Publish: 'Publish',
            Private:'Private',
            withoutname: 'Deck without a name',
            Settings: 'Settings',
            Test: 'Test',
            json: 'Import Questions',
            importQuestions: 'Import Questions',
            chooseFile: 'Choose Files',
            noFileChosen: 'No file chosen',
            acceptedTxtOnly: 'Accepts .txt files in the simplified format',
            uploadFromFile: 'Upload from a file',
            pasteSimplifiedText: 'Paste simplified text format',
            pasteSimplifiedTextPlaceholder: 'Paste your questions in the simplified text format here...',
            pasteOrUploadContent: 'Please paste content or upload a file first',
            validating: 'Validating...',
            mychild: 'My children',
            challenge: 'Daily challenges',
            personaldata: 'Personal data',
            save: 'Save',
            emailconfimmsg: 'After you change your email, you will need to confirm it. We will send you a confirmation email.',
            current: 'Current',
            new: 'New',
            whatnext: 'What is next?',
            overviewh2: 'Add a question deck from Zubroteka',
            watch: 'Watch the learning',
            hide: 'Hide',
            whatmaterial: 'What is that material?',
            deck: 'Deck',
            Edit: 'Edit',
            update: 'Update',
            shortDescription: 'Short Description',
            longDescription: 'Long Description',
            mainSubject: 'Subject',
            deckCover: 'Deck Cover',
            smallInParentheses: '(small)',
            largeInParentheses: '(large)',
            clickToUploadSmallImage: 'Click to upload small image',
            clickToUploadLargeImage: 'Click to upload large image',
            clickToChange: 'Click to change',
            selectStatus: 'Select Status',
            Hidden: 'Hidden',
            'Work In Progress': 'Work In Progress',
            Deleted: 'Deleted',
            mqa2: 'Select question decks from Zubroteka or from decks you already use. The selected decks will be visible to all students.',
            mqa3: 'You can group decks into folders in any order you want. You can also change the order of the elements. This order and folder names will be displayed to all students.',
            mq4: 'Restricted folder access',
            mqa4: 'You can group decks into folders in any order you want. You can also change the order of the elements. This order and folder names will be displayed to all students.',
            whatpeople: 'People - what is it?',
            pq1: 'Invite students from the list. The material will appear in their app automatically.',
            pq2: 'You can invite more teachers to help you gather materials or invite people.',
            Invitepeople: 'Invite people',
            oa2: 'Assemble a class of teachers and students',
            oq3: 'Watch the learning',
            oa3: 'Monitor overall and individual statistics',
            loginmsg: 'successfully logged in',
            signupmsg: 'user create successfully',
            logoutmsg: 'user logout successfully',
            passwordChanged: 'Password changed successfully',
            emailupdated: 'Email updated successfully',
            user: "User",
            "validation": {
                "questionrequired": "Question is required",
                "answerrequired" : "Answer is required",
                "cardNameRequired": "Card name is required",
                "atLeastOneAnswer": "At least one answer is required",
                "testMinimumOptions": "At least 2 answer options are required for multiple choice",
                "testNeedsCorrect": "Please mark at least one answer as correct",
                "userrequired": "Username is required",
                "usercharacter": "Username must be at least 4 characters",
                "passwordrequired": "Password is required",
                "uniquekey_required": "Unique key is required",
                "uniquekey_invalid": "Unique key must follow the format 000-000-000",
                "name_required": "First name is required",
                "lastname_required": "Last name is required",
                "email_required": "Email is required",
                "email_invalid": "Invalid email format",
                "password_required": "Password is required",
                "password_min": "Password must be at least 8 characters",
                "terms_required": "You must agree to the terms and conditions",
                "oldPasswordRequired": "Old password is required",
                "newPasswordRequired": "New password is required",
                "passwordvalidation": "Password must be more then 6 letters",
                "deckNameRequired":"Deck name is required",
                "shortDescriptionRequired":"Short description is required",
                "longDescriptionRequired":"Long description is required",
                "mainSubjectRequired":"Subject is required",
                "regionRequired":"Region is required",
                "smallImageUrlRequired":"Small image URL is required",
                "longImageUrlRequired":"Long image URL is required",
                "statusRequired":"Status is required"
            },
            or: 'or',
            forgotpass: "I forgot my password.",
            zubusstudent: 'Zubrus app for students',
            dowenloadtext: "Available to students via the Google Play Store and App Store.",
            creatematerial: 'Do you want to create learning materials?',
            fordeveloper: 'Zubrus for developers',
            opth1: 'Enter the security code you received in your email.',
            otpdes: 'To protect the personal data of users, please authorize this login.',
            otpcode: 'Send new code',
            seconds: 'seconds',
            sendOtp: 'Send OTP',
            verifyOtp: 'Verify OTP',
            loginWithPassword: 'Login with password',
            loginWithOtp: 'Login with OTP',
            otpSentSuccess: 'OTP sent to your email',
            otpRequestFailed: 'Failed to send OTP',
            otpVerifyFailed: 'Invalid or expired OTP',
            changeEmail: 'Change email',
            loginFailed: 'Login failed',
            loginTimeout: 'Too many failed attempts. Please wait.',
            loginAttemptsExceeded: 'Too many failed attempts. Account temporarily locked.',
            remainingAttempts: '{{count}} attempts remaining',
            creaeuser: 'Create a new user',
            months: [
                "January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
            ],
            today: "Today",
            yesterday: "Yesterday",
            last7Days: "Last 7 Days",
            thisMonth: "This Month",
            nocard: "No cards found",
            Card:"Card",
            attemptsLeft: "Attemps Left",
            tryAgainIn: 'Try Again In',
            regulardeck: 'Regular deck',
            createq: ' Create your own questions.',
            autoai: "Automatic AI",
            uploadpdf: 'Upload the material file in PDF format and the system will automatically generate the questions.',
            newdeck: 'New Deck',
            ALL: 'ALL',
            PUBLISHED: 'PUBLISHED',
            HIDDEN: 'HIDDEN',
            PRIVATE: 'PRIVATE',
            WORK_IN_PROGRESS: 'WORK_IN_PROGRESS',
            createnewuser: 'Create a new user',
            importcsv: 'Import .xls or .csv',
            occupiedchar: 'Occupied "chairs"',
            ordermore: 'Order more',
            class_management: {
                title: 'Class Management',
                create_class: 'Create Class',
                edit_class: 'Edit Class',
                delete_class: 'Delete Class',
                class_name: 'Class Name',
                class_description: 'Class Description',
                class_grade: 'Class Grade',
                class_subject: 'Class Subject',
                class_status: 'Class Status',
                active: 'Active',
                inactive: 'Inactive',
                delete_confirm: 'Are you sure you want to delete the class "{name}"?',
                delete_warning: 'This action cannot be undone.',
                delete_success: 'Class deleted successfully',
                create_success: 'Class created successfully',
                edit_success: 'Class updated successfully',
                error_occurred: 'An error occurred. Please try again.',
                bulk_actions: 'Bulk Actions',
                search_placeholder: 'Search classes...',
                filter_by: 'Filter by',
                sort_by: 'Sort by',
                total_students: 'Total Students',
                class_actions: 'Actions',
                class_created: 'Created Date',
                class_teacher: 'Teacher',
                class_students: 'Students',
                no_classes: 'No classes found',
                export_csv: 'Export to CSV',
                import_csv: 'Import from CSV',
                class_statistics: 'Class Statistics',
                average_performance: 'Average Performance',
                completion_rate: 'Completion Rate',
                last_activity: 'Last Activity'
            },
            parent_management: {
                title: 'Parent Management',
                add_parent: 'Add Parent',
                add_success: 'Parent added successfully',
                add_failed: 'Failed to add parent',
                search_students: 'Search students by name or email...',
                no_students: 'No students found',
                select_child_required: 'Select at least one child',
                children_hint: 'A parent can be linked to one or more students.',
                import_csv: 'Import CSV',
                search_placeholder: 'Search parents...',
                filter_by_status: 'Filter by Status',
                active: 'Active',
                inactive: 'Inactive',
                last_login: 'Last Login',
                edit_success: 'Parent updated successfully',
                delete_success: 'Parent deleted successfully',
                phone: 'Phone',
                status: 'Status',
                children: 'Children',
                registration_date: 'Registration Date',
                actions: 'Actions',
                no_parents: 'No parents found',
                bulk_actions: 'Bulk Actions',
                export_csv: 'Export to CSV',
                parent_details: 'Parent Details',
                parent_statistics: 'Parent Statistics',
                total_children: 'Total Children',
                average_activity: 'Average Activity',
                last_activity: 'Last Activity'
            },
            teacher_management: {
                title: 'Teacher Management',
                add_teacher: 'Add Teacher',
                import_csv: 'Import CSV',
                search_placeholder: 'Search teachers...',
                filter_by_status: 'Filter by status',
                active: 'Active',
                inactive: 'Inactive',
                edit_teacher: 'Edit Teacher',
                edit_success: 'Teacher updated successfully',
                edit_failed: 'Failed to update teacher',
                delete_title: 'Delete teacher?',
                delete_success: 'Teacher deleted successfully',
                delete_failed: 'Failed to delete teacher',
                subjects: 'Subjects to teach',
                country: 'Country',
                roles: 'Roles',
                teacher_id: 'Teacher ID',
                schools: 'Schools',
                last_login: 'Last Login',
                status: 'Status',
                actions: 'Actions',
                name: 'Name',
                email: 'Email',
                phone: 'Phone',
                classes: 'Classes',
                registration_date: 'Registration Date',
                total_decks: 'Total Decks',
                decks_per_class: 'Decks per Class',
                personal_info: 'Personal Information',
                delete_confirm: 'Are you sure you want to delete this teacher?',
                error_loading_teacher: 'Error loading teacher details',
                teacher_not_found: 'Teacher not found'
            },
            statistics: 'Statistics',
            total_students: 'Total Students',
            average_completion: 'Average Deck Completion',
            recent_activity: 'Recent Activity',
            loading: 'Loading...',
            view: 'View',
            students: 'Students',
            user_management: {
                title: 'User Management',
                add_user: 'Add User',
                import_csv: 'Import CSV',
                search_placeholder: 'Search users...',
                filter_by_role: 'Filter by Role',
                user_id: 'User ID',
                onetime_key: 'Onetime Key',
                user_name: 'User Name',
                last_name: 'Last Name',
                email: 'Email',
                role: 'Role',
                actions: 'Actions',
                view: 'View',
                edit: 'Edit',
                remove: 'Remove',
                delete_confirm: 'Are you sure you want to delete this user?',
                delete_success: 'User deleted successfully',
                edit_success: 'User updated successfully',
                error_loading_user: 'Error loading user details',
                user_not_found: 'User not found'
            },
            creator_management: {
                title: 'Creator Management',
                add_creator: 'Add Creator',
                import_csv: 'Import CSV',
                search_placeholder: 'Search creators...',
                filter_by_status: 'Filter by Status',
                creator_id: 'Creator ID',
                creator_name: 'Creator Name',
                email: 'Email',
                status: 'Status',
                total_decks: 'Total Decks',
                total_students: 'Total Students',
                average_rating: 'Average Rating',
                last_activity: 'Last Activity',
                actions: 'Actions',
                view: 'View',
                edit: 'Edit',
                remove: 'Remove',
                active: 'Active',
                inactive: 'Inactive',
                edit_creator: 'Edit Creator',
                delete_title: 'Delete creator?',
                delete_confirm: 'Are you sure you want to delete this creator?',
                delete_success: 'Creator deleted successfully',
                delete_failed: 'Failed to delete creator',
                edit_success: 'Creator updated successfully',
                edit_failed: 'Failed to update creator',
                add_success: 'Creator added successfully',
                error_loading: 'Failed to load creators',
                error_loading_creator: 'Error loading creator details',
                creator_not_found: 'Creator not found'
            },
            classDeletedSuccess: "Class deleted successfully",
            main_answer: 'Main answer',
            acceptable_answers: 'Acceptable answers',
            updateclass: 'Update class',
            editclass: 'Edit class',
            deckremove: 'Deck successfully removed.',
            areYouSureYouWantToDelete: "Are you sure you want to delete this card?",
            areYouSureYouWantToDeleteDeck: "Are you sure you want to delete this deck?",
            Delete: "Delete",
            Cancel:"Cancel",
            importFileAndCreateDeck:"Import File & Create Deck",
            manualAdd:"Manual Add",
            Create:"Create",
            validatingFile: "Validating File...",
            pleaseWaitProcessing: "Please wait while we process your deck file",
            sampleDeckPreview: "Sample Deck Preview",
            // Toast messages
            fileShouldBeTextDocument: "File should be text document",
            authenticationRequired: "Authentication required. Please log in again.",
            fileValidatedSuccessfully: "File validated successfully!",
            validationFailed: "Validation failed: {errorCount} error(s) found",
            validationFailedGeneric: "Validation failed. Please check your file format.",
            invalidFileFormat: "Invalid file format. Please check your deck structure.",
            authenticationFailed: "Authentication failed. Please log in again.",
            fileTooLarge: "File too large. Please use a smaller file.",
            requestTimedOut: "Request timed out. Please try again.",
            networkError: "Network error. Please check your connection and try again.",
            errorProcessingFile: "Error processing file. Please try again.",
            noValidatedFileContent: "No validated file content available",
            deckAddedSuccessfully: "Deck added successfully!",
            errorAddingDeck: "Error adding deck. Please try again.",
            deckCreationCancelled: "Deck creation cancelled",
            "first_name": "First Name",
            "last_name": "Last Name",
            "preferred_language": "Preferred Language",
            "country_code": "Country Code",
            "gender": "Gender",
            "male": "Male",
            "female": "Female",
            "unspecified": "Unspecified",
            "birth_date": "Birth Date",
            "nickname": "Nickname",
            "edit_student": "Edit Student",
            "student_update_success": "Student updated successfully",
            "creation_date": "Creation Date",
            "user_not_found_or_direct_access": "User data not found or page accessed directly.",
            "back_to_user_list": "Back to User List",
            "user_details": "User Details",
            "username": "Username",
            "roles": "Roles",
            "student_deleted_successfully": "Student deleted successfully!",
            "delete_student_title": "Delete Student?",
            "delete_student_message": "Are you sure you want to permanently delete this student? This action cannot be undone.",
            "add_student_title": "Add New Student",
            "student_added_successfully": "Student added successfully!",
            "one_time_key": "One-Time Key",
            "key_copied": "Key copied to clipboard!",
            "copy_key": "Copy key",
            quiz: {
                title: "Quiz",
                publicDecks: "Public Decks",
                library: "LIBRARY",
                chooseDeckTitle: "Choose your deck",
                decksForDisciplines: "decks · for various disciplines and classes.",
                quickFilter: {
                    history: "History",
                    biology: "Biology",
                    geography: "Geography",
                    mathematics: "Mathematics",
                    languages: "Languages",
                },
                chooseDeck: "Choose a deck to start learning",
                deckNotFound: "Deck not found",
                playQuiz: "Play Quiz",
                welcome: "Welcome to Zubrus Quiz!",
                enterCodeToJoin: "Enter the quiz code to join",
                codePlaceholder: "Enter code...",
                codeRequired: "Please enter a quiz code",
                joinQuiz: "Join Quiz",
                join: "Join",
                askTeacherForCode: "Ask your teacher for the quiz code",
                quizNotFound: "Quiz not found",
                checkCodeAndTryAgain: "Please check your code and try again",
                backToHome: "Back to Home",
                enterYourDetails: "Enter your details",
                yourName: "Your Name",
                namePlaceholder: "Enter your name...",
                nameRequired: "Please enter your name",
                nameMinLength: "Name must be at least 2 characters",
                iAmA: "I am a",
                student: "Student",
                teacher: "Teacher",
                startQuiz: "Start Quiz",
                differentCode: "Use a different code",
                questions: "questions",
                minutes: "min",
                score: "Score",
                correctAnswer: "Correct!",
                wrongAnswer: "Wrong!",
                timeUp: "Time's up!",
                nextQuestion: "Next Question",
                finishQuiz: "Finish Quiz",
                questionOf: "{{current}} / {{total}}",
                seeResults: "See Results",
                noQuestions: "No questions available",
                quizComplete: "Quiz Complete!",
                greatJob: "Great job",
                correctAnswers: "Correct",
                wrongAnswers: "Wrong",
                totalScore: "Score",
                playAgain: "Play Again",
                newQuiz: "Join Another Quiz",
                selectCardsInstruction: "Select cards for the quiz (minimum 1)",
                selectAll: "Select All",
                deselectAll: "Deselect All",
                cardsSelected: "cards selected",
                generateQuiz: "Generate Quiz",
                quizLobby: "Quiz Lobby",
                scanToJoin: "Scan QR code to join the quiz",
                copy: "Copy",
                studentsJoined: "Students Joined",
                waitingForStudents: "Waiting for students to join...",
                waitingForTeacher: "Waiting for teacher to start the quiz...",
                studentsWaiting: "students are waiting",
                studentsAnswered: "Students answered",
                quizResults: "Quiz Results",
                sessionId: "Session",
                totalStudents: "Total Students",
                averageScore: "Average Score",
                bestScore: "Best Score",
                leaderboard: "Leaderboard",
                name: "Name",
                time: "Time",
                exportResults: "Export Results",
                exportComingSoon: "Export feature coming soon!",
                tapToFlip: "Tap to reveal answer",
                tapToSeeQuestion: "Tap to see question",
                getReady: "Get ready",
                joinCode: "Join code",
                waitingToStart: "Waiting for the quiz to start",
                waitingForQuestion: "Waiting for the next question...",
                waitingForNext: "Waiting for the next question...",
                loadingQuestion: "Loading question...",
                timesUp: "Time's up!",
                answerSubmitted: "Answer submitted!",
                submitAnswer: "Submit answer",
                typeYourAnswer: "Type your answer...",
                secondsPerQuestion: "Seconds / question",
                creating: "Creating...",
                joining: "Joining...",
                joinFailed: "Could not join the quiz. Check the code and try again.",
                sessionNotFound: "Quiz session not found",
                sessionNotFoundHint: "Please create the quiz again.",
                noParticipants: "No participants",
                seeTeacherLeaderboard: "Your teacher can see the full leaderboard.",
            },
            Learning: "Learning",
            Zubrinti: "Zubrinti",
            previous: "Previous",
            "csv_import": {
                "title": "Import Students from CSV",
                "download_sample_title": "Download Sample CSV",
                "download_sample_description": "Download the sample CSV file to see the required format for importing students.",
                "download_sample_button": "Download Sample",
                "upload_title": "Upload CSV File", 
                "choose_file": "Choose File",
                "selected_file": "Selected: {filename}",
                "import_progress_title": "Import Progress",
                "processing_text": "Processing: {current} of {total} students",
                "successful_count": "✓ {count} successful",
                "failed_count": "✗ {count} failed",
                "errors_found": "Errors Found:",
                "processing": "Processing...",
                "importing": "Importing...",
                "import_button": "Import",
                "please_select_valid_csv": "Please select a valid CSV file",
                "please_select_csv": "Please select a CSV file",
                "csv_parsing_error": "CSV parsing error: {error}",
                "csv_no_valid_data": "CSV file contains no valid data rows",
                "import_success": "Successfully imported {count} students",
                "import_completed": "Import completed: {success} successful, {failed} failed",
                "error_processing_csv": "Error processing CSV file",
                "validation_first_name_required": "First name is required",
                "validation_last_name_required": "Last name is required",
                "validation_email_required": "Email is required",
                "validation_email_invalid": "Invalid email format",
                "validation_gender_invalid": "Gender must be MALE, FEMALE, or UNSPECIFIED",
                "validation_duplicate_email": "Duplicate email \"{email}\" found in CSV",
                "error_email_exists": "Email \"{email}\" already exists in the system",
                "error_invalid_data": "Invalid student data provided",
                "error_validation_failed": "Validation failed - check required fields", 
                "error_server_error": "Server error - please try again later",
                "error_network": "Network connection error - check your internet connection",
                "error_timeout": "Request timeout - server is taking too long to respond",
                "error_failed_create": "Failed to create student",
                "error_csv_empty": "CSV file is empty",
                "error_missing_headers": "Missing required headers: {headers}"
            }
        },
    },
    lt: {
        translation: {
            login: "Prisijungti",
            register: 'Registruotis',
            uniquekey: 'Unikalus raktas',
            keyinfo: ' Kas tai?',
            name: 'Vardas',
            lastname: 'Pavardė',
            keydes: 'Tai vieną kartą reikalingas kodas, kurį gausite iš Jūsų mokyklos personalo. Jis leis susikurti paskyrą.',
            firstTime: "Pirmą kartą?",
            signup: "Registruotis",
            copyright: '© 2025 Zubrus. Visos teisės saugomos.',
            email: 'El. paštas',
            password: 'Slaptažodis',
            confirmmsg: 'Į el. paštą išsiųsime patvirtinimo laišką.',
            agree: 'Sutinku su',
            rules: 'Taisyklėmis',
            and: 'ir',
            policy: 'Privatumo politika',
            confirmemail: 'Patvirtinkite savo el. pašto adresą',
            emailmsg: 'Išsiuntėme patvirtinimą į Jūsų el. pašto adresą {{email}}. Patvirtinimas reikalingas tam, kad jei netyčia pamirštumėte slaptažodį, būtų lengva jį atkurti.',
            back: "Eiti į Zubrus",
            profile: 'Profilis',
            creator: 'Norite tapti kūrėju?',
            creatordes: 'Kurkite savo kalades ir medžiagą.',
            want: 'Noriu',
            Personaldata: 'Asmeniniai duomenys',
            changepassword: 'Keisti slaptažodį',
            changelan: 'Keisti kalbą,',
            logout: 'Atsijungti',
            becomecreator: 'Noriu tapti kūrėju',
            becomecreatorh1: 'Norite kurti savo Zubrus medžiagą?',
            becomecreatorh2: 'Galbūt norėtumėte, kad jas pasiektų ne tik Jūsų mokiniai bet ir kiti Lietuvos vaikai?',
            becomecreatorh3: 'O galbūt norėtumėte dirbti su Zubrus ir užsidirbti?',
            becomecreatorh4: 'Užsiregistruokite tiesiog paspaudę mygtuką ir susisieksime su Jumis!',
            signup2: 'Užsiregistruoti!',
            registered: 'Užsiregistravote!',
            newsoon: 'Jau greitai sugrįšime su žiniomis.',
            myclasses: 'Mano klasės',
            createclass: 'Kurti klasę',
            picture: 'Paveiksliukas',
            student: 'mokinys',
            teacher: "mokytojas",
            createfirstclass: 'Sukurkite pirmąją savo klasę.',
            class: 'Klasės',
            zubroteka: 'Zubroteka',
            workshop: "Dirbtuvėss",
            september: '2024 m. Rugsėjis',
            menuItems: {
                classes: "Klasės",
                zubroteka: "Zubroteka",
                workshops: "Dirbtuvės",
                Contentcreator: 'Turinio kūrėjas',
                admin: 'administratorius'
            },
            adminmenu: {
                userlist: 'Naudotojų sąrašas',
                classlist: 'klasių sąrašas',
                parentslist: 'tėvų sąrašas',
                teacherlist: 'mokytojų sąrašas',
                creatorList: 'kūrėjų sąrašas',
                payments: 'Mokėjimai',
                service: 'Servisas'
            },
            tabs: {
                overview: "Apžvalga",
                material: "Medžiaga",
                people: "Žmonės"
            },
            filter: {
                popularity: "Pagal populiarumą",
                newest: "Pagal naujumą",
                recently_watched: "Pagal paskutines žiūrėtas"
            },
            average: 'Vid.',
            activity: 'aktyvumas',
            result: 'rezultatas',
            mostactive: 'Aktyviausi',
            passive: 'Pasyviausis',
            best: 'Geriausi',
            worst: 'Prasčiausi',
            deckspopularity: 'Kaladės pagal populiarumą',
            deckscore: 'Kaladės pagal vidutinį rezultatą',
            edit: 'Redaguoti',
            add: 'Pridėti',
            castle: 'Kaladę',
            folder: 'Aplanką',
            editmode: 'Redagavimo rėžimas',
            adjust: "stumdykite ir perdėliokite elementus, trinkite nereikalingas kalades.",
            allsee: 'Mato visi',
            nosee: 'Nemato niekas',
            Optional: 'Pasirinktinai',
            whosee: 'Kas mato',
            uncheck: 'Atžymėti visus',
            question: 'Klausimas',
            questions: 'Klausimai',
            about: "Apie kaladę",
            Statistics: 'Statistika',
            general: 'Bendra',
            all: 'Visi',
            people: 'žmones',
            search: 'Paieška',
            Performance: 'Rezultatyvumas',
            remove: 'Pašalinti',
            fromclass: 'iš klasės?',
            dltmsg: 'Pašalintas žmogus nebegalės matyti jūsų klasės turinio ir jo statistika pradings.',
            cancel: "Atšaukti",
            selectSchool: 'Pasirinkite mokyklą',
            noSchoolsFound: 'Mokyklų nerasta',
            continue: 'Tęsti',
            pleaseSelectSchool: 'Prašome pasirinkti mokyklą, kad tęstumėte',
            failedToFetchSchools: 'Nepavyko gauti mokyklos informacijos',
            schoolSelectionRequired: 'Mokyklos pasirinkimas yra privalomas, kad tęstumėte. Prašome susisiekti su administratoriumi.',
            noSchoolsMessage: 'Šiuo metu neturite prieigos prie jokių mokyklų.',
            singleSchoolAutoSelected: 'Ši mokykla buvo automatiškai pasirinkta jums.',
            catalog: 'Katalogas',
            Favorites: 'Pamėgtos',
            useit: 'Jau naudoju',
            Alldisciplines: 'Visos disciplinos',
            allages: ' Visiems amžiams',
            Allauthors: ' Visi autoriai',
            Bypopularity: 'Pagal populiarumą',
            detail: 'Detaliau',
            answer: 'Atsakymas',
            answers: 'Atsakymai',
            Prompter: 'Sufleris',
            feedback: 'Atsiliepimas kūrėjui',
            answerType: "Atsakymo tipas",
            answerTypeInput: "Įvesties",
            answerTypeMemory: "Atminties",
            answerTypeTest: "Testas",
            complexity: "Sudėtingumas",
            complexityVeryEasy: '1 Labai lengvas',
            complexityEasy: '2 Lengvas',
            complexityMedium: '3 Vidutinis',
            complexityHard: '4 Sunkus',
            complexityVeryHard: '5 Labai sunkus',
            cardName: 'Kortelės pavadinimas',
            addCard: 'Pridėti kortelę',
            editCard: 'Redaguoti kortelę',
            editDeck: 'Redaguoti kaladę',
            addAnswer: 'Pridėti atsakymą',
            newQuestion: 'Naujas klausimas',
            addHint: 'Pridėti suflerį',
            characters: 'simbolių',
            clickToAddImage: 'Spustelėkite, norėdami pridėti paveikslėlį',
            addMore: 'Pridėti daugiau',
            addImage: 'Pridėti paveikslėlį',
            addAudio: 'Pridėti garsą',
            addText: 'Pridėti tekstą',
            aiAudioSection: 'DI / Garsas (nebūtina)',
            aiAudioHelper: 'Atkūrimo prioritetas: garso URL → TTS iš DI teksto → tekstas iš kortelės dalių.',
            ttsTextOptional: 'TTS tekstas (nebūtina)',
            ttsTextPlaceholder: 'Tekstas TTS, jei nėra garso URL',
            audioUrlOptional: 'Garso URL (nebūtina)',
            fillFromText: 'Užpildyti iš teksto',
            uploadAudio: 'Įkelti',
            strictCheck: 'Griežtas tikrinimas',
            move: 'Perkelti',
            deckUpdatedSuccess: 'Kortelė sėkmingai atnaujinta',
            deckCardAddedSuccess: 'Kortelė sėkmingai pridėta',
            enterText: 'Įveskite tekstą...',
            inputHint: 'Įvesties užuomina',
            inputHintPlaceholder: 'Užuomina kaip atsakyti...',
            addInputHint: 'Pridėti įvesties užuominą',
            clickToAdd: 'Spustelėkite, kad pridėtumėte',
            uploadImages: 'Įkelti paveikslėlius',
            uploadImage: 'Įkelti paveikslėlį',
            clickToUploadImages: 'Spustelėkite, norėdami įkelti paveikslėlius',
            uploading: 'Įkeliama...',
            uploadImageCount: 'Įkelti {{count}} paveikslėlį(-us)',
            uploadFiles: 'Įkelti failus',
            uploadImagesAndAudio: 'Paveikslėliai ir garso failai',
            clickToUploadFiles: 'Spustelėkite, norėdami įkelti failus',
            supportsImagesAndAudio: 'Palaikomi paveikslėliai ir garso failai',
            selectedFiles: 'Pasirinkti failai',
            uploadFileCount: 'Įkelti {{count}} failą(-us)',
            Send: 'Siųsti',
            assignToDeck: 'Priskirti kaladei',
            assignCardToAnotherDeck: 'Priskirti kortelę',
            searchDecks: 'Ieškoti kaladžių...',
            searchCards: 'Ieškoti kortelių...',
            selectAtLeastOneDeck: 'Pasirinkite bent vieną kaladę',
            cardAssignedSuccess: 'Kortelė sėkmingai priskirta {{count}} kaladei(-ėms)',
            cardAssignedError: 'Nepavyko priskirti {{count}} kaladei(-ėms)',
            cardsAssignedSuccess: '{{count}} kortelė(-ės) sėkmingai priskirta(-os)',
            selected: 'pasirinkta',
            selectDecks: 'Pasirinkite kalades priskyrimui',
            selectACard: 'Pasirinkite kortelę',
            selectCardToAssign: 'Pasirinkite kortelę priskyrimui',
            selectCardsToAssign: 'Pasirinkite korteles priskyrimui',
            selectCards: 'Pasirinkite korteles',
            selectTargetDecks: 'Pasirinkite tikslines kalades',
            step1of2: '1 žingsnis iš 2',
            noCardsFound: 'Kortelių nerasta',
            noCardsInDeck: 'Šioje kaladėje nėra kortelių',
            noCardsToAssign: 'Nėra kortelių priskyrimui. Pirmiausia pridėkite kortelių.',
            select: 'Pasirinkti',
            selectAll: 'Pasirinkti visus',
            deselectAll: 'Atžymėti visus',
            cardSelected: 'kortelė pasirinkta',
            cardsSelected: 'kortelės pasirinktos',
            decksSelected: 'kaladė(-ės) pasirinkta(-os)',
            selectDeck: 'Pasirinkti kaladę',
            importCard: 'Importuoti kortelę',
            cardView: 'Kortelės',
            listView: 'Sąrašas',
            moveCardUp: 'Perkelti aukštyn',
            moveCardDown: 'Perkelti žemyn',
            dragToReorder: 'Tempkite, kad pakeistumėte tvarką',
            savingOrder: 'Išsaugoma tvarka...',
            cardOrderSaved: 'Kortelių tvarka išsaugota',
            cardOrderFailed: 'Nepavyko išsaugoti kortelių tvarkos',
            cardOrderLoginRequired: 'Prisijunkite, kad išsaugotumėte kortelių tvarką',
            myDecks: 'Mano kaladės',
            allDecks: 'Visos kaladės',
            importCardsFromDeck: 'Importuoti korteles iš kaladės',
            selectCardsToImport: 'Pasirinkite korteles importavimui',
            selectSourceDeck: 'Pasirinkite kaladę, iš kurios importuoti',
            chooseSourceDeck: 'Pasirinkite šaltinio kaladę',
            selectCardsToImportHint: 'Pasirinkite korteles importavimui',
            importing: 'Importuojama...',
            import: 'Importuoti',
            cardsImportedSuccess: 'Kortelės sėkmingai importuotos',
            deckDeletedSuccess: 'Kortelė sėkmingai pašalinta',
            deckIdMissing: 'Kaladės ID nerastas',
            fixValidationErrors: 'Prašome ištaisyti klaidas prieš importuojant',
            multipleChoice: 'Kelių pasirinkimų',
            answerOption: 'Atsakymo variantas',
            markAsCorrect: 'Pažymėti kaip teisingą',
            markAsWrong: 'Pažymėti kaip neteisingą',
            correctAnswer: '✓ Teisingas atsakymas',
            wrongAnswer: 'Neteisingas atsakymas',
            addAnswerOption: 'Pridėti atsakymo variantą',
            testAnswerInfo: 'Spustelėkite raidę/varnelę, kad pažymėtumėte teisingą atsakymą. Reikia bent 2 variantų, 1 turi būti teisingas.',
            correct: 'teisingas',
            total: 'iš viso',
            mark: 'Žyma',
            markPlaceholder: 'pvz. Egzaminas, Testas',
            markHelperText: 'Rodoma kortelės viršuje',
            mainSubjectPlaceholder: 'pvz. Matematika, Mokslas',
            subject: 'Dalykas',
            gradeLabel: 'Klasė',
            schoolGrades: 'Mokyklos klasės',
            schoolGradesPlaceholder: 'pvz. 5, 6-8, 10-12',
            schoolGradesHelperText: 'Neprivaloma. Nurodykite tikslines klases.',
            region: 'Regionas',
            selectRegion: 'Pasirinkite regioną',
            next: 'Kitas',
            assign: 'Priskirti',
            assigning: 'Priskiriama...',
            noDecksFound: 'Kaladžių nerasta',
            noOtherDecks: 'Nėra kitų kaladžių',
            cards: 'Kortelių',
            deckName: 'Kaladė',
            status: 'Būsena',
            authorName: 'Autoriaus vardas',
            createdBy: 'Kūrėjas',
            language: 'Kalba',
            countries: 'Šalys',
            creationDate: 'Sukūrimo data',
            published: 'PUBLIKUOTA',
            deckworkshop: 'Kaladžių dirbtuvės',
            creatdeck: 'Sukurti kaladę',
            addDeck: 'Importuoti',
            verifyAgain: 'Tikrinti iš naujo',
            askAI: 'Klausti DI',
            askingAI: 'Klausti DI...',
            DeckInformation: 'Kaladės informacija',
            DeckSummary: 'Kaladės aprašymas',
            DeckWarnings: 'Įspėjimai',
            DeckErrors: 'Klaidos',
            validatingFile: 'Validating File...',
            pleaseWaitProcessing: 'Please wait while we process your deck file',
            processingAndAdding: 'Apdorojama...',
            sampleDeckPreview: 'Kaladės patikrinimo rezultatai',
            ALL: 'VISOS',
            PUBLISHED: 'PUBLIKUOTA',
            HIDDEN: 'PASLĖPTOS',
            PRIVATE: 'PRIVAČIOS',
            WORK_IN_PROGRESS: 'RENGIAMOS',
            Draft: 'Juodraštis',
            Published: 'Publikuotos ',
            Publish: 'Publikuoti',
            Private:'Privačios',
            withoutname: 'Kaladė be pavadinimo',
            Settings: 'Nustatymai',
            Test: 'Peržiūra',
            json: 'Importuoti klausimus',
            importQuestions: 'Importuoti klausimus',
            chooseFile: 'Pasirinkti failą',
            noFileChosen: 'Failas nepasirinktas',
            acceptedTxtOnly: 'Priimami tik .txt failai supaprastintu formatu',
            uploadFromFile: 'Įkelti iš failo',
            pasteSimplifiedText: 'Įklijuokite supaprastintą tekstinį formatą',
            pasteSimplifiedTextPlaceholder: 'Įklijuokite savo klausimus supaprastintu tekstiniu formatu čia...',
            pasteOrUploadContent: 'Įklijuokite turinį arba įkelkite failą',
            validating: 'Tikrinama...',
            mychild: 'Mano vaikai',
            challenge: 'Dienos iššūkiai',
            personaldata: 'Asmeniniai duomenys',
            save: 'Išsaugoti',
            emailconfimmsg: 'Pakeitę el. paštą, jį turėsite patvirtinti. Išsiųsime patvirtinimo laišką.',
            current: 'Esamas ',
            new: 'Naujas',
            whatnext: 'Kas toliau?',
            overviewh2: 'Pridėkite klausimų kaladę iš Zubrotekos',
            watch: 'Stebėkite mokymąsį',
            hide: 'Neberodyti',
            whatmaterial: 'Kas ta medžiaga?',
            deck: 'kaladė',
            Edit: 'Redaguoti',
            update: 'Atnaujinti',
            shortDescription: 'Trumpas aprašymas',
            longDescription: 'Ilgas aprašymas',
            mainSubject: 'Dalykas',
            deckCover: 'Kaladės viršelis',
            smallInParentheses: '(mažas)',
            largeInParentheses: '(didelis)',
            clickToUploadSmallImage: 'Spustelėkite, norėdami įkelti mažą paveikslėlį',
            clickToUploadLargeImage: 'Spustelėkite, norėdami įkelti didelį paveikslėlį',
            clickToChange: 'Spustelėkite, norėdami pakeisti',
            selectStatus: 'Pasirinkti būseną',
            Hidden: 'Paslėptos',
            'Work In Progress': 'Rengiamos',
            Deleted: 'Ištrintos',
            mqa2: 'Parinkite klausimų kalades iš Zubrotekos ar Jūsų jau naudojamų kaladžių. Parinktos kaladės bus matomos visiems mokiniams.',
            mqa3: 'Galite sugrupuoti kalades į aplankus pagal norimą tvarką. Taip pat, galite keisti elementų eiliškumą. Tokia tvarka ir aplankų pavadinimai bus atvaizduojami visiems mokiniams',
            mq4: 'Ribota aplanko prieeiga',
            mqa4: 'Galite sugrupuoti kalades į aplankus pagal norimą tvarką. Taip pat, galite keisti elementų eiliškumą. Tokia tvarka ir aplankų pavadinimai bus atvaizduojami visiems mokiniams',
            whatpeople: 'Žmonės - kas tai?',
            pq1: 'Kvieskite mokinius iš sarašo. Medžiaga atsiras jų programėlėje automatiškai.',
            pq2: 'Galite pakviesti daugiau mokytojų, kurie talkins Jums rinkdami medžiagą ar kviesdami žmones.',
            Invitepeople: 'Pakvieskite žmones',
            oa2: 'Suburkite klasę iš mokytojų ir mokinių',
            oq3: 'Stebėkite mokymąsį',
            oa3: 'Stebėkite bendrą ir individualią statistiką',
            loginmsg: 'sėkmingai prisijungė',
            signupmsg: 'vartotojas sukurtas sėkmingai',
            logoutmsg: 'vartotojas atsijungė sėkmingai',
            user: 'Vartotojo',
            passwordChanged: 'Slaptažodis pakeistas sėkmingai',
            emailupdated: 'El. paštas atnaujintas sėkmingai',
            "validation": {
                "questionrequired": "Klausimas būtinas",
                "answerrequired":" Būtinas atsakymas",
                "cardNameRequired": "Kortelės pavadinimas yra privalomas",
                "atLeastOneAnswer": "Būtinas bent vienas atsakymas",
                "testMinimumOptions": "Kelių pasirinkimų klausimui reikia bent 2 atsakymų variantų",
                "testNeedsCorrect": "Pažymėkite bent vieną atsakymą kaip teisingą",
                "userrequired": "Reikalingas vartotojo vardas",
                "usercharacter": "Vartotojo vardas turi būti bent 4 simbolių",
                "passwordrequired": "Reikalingas slaptažodis",
                "uniquekey_required": "Unikalus kodas yra privalomas",
                "uniquekey_invalid": "Unikalus kodas turi atitikti formatą 000-000-000",
                "name_required": "Vardas yra privalomas",
                "lastname_required": "Pavardė yra privaloma",
                "email_required": "El. paštas yra privalomas",
                "email_invalid": "Neteisingas el. pašto formatas",
                "password_required": "Slaptažodis yra privalomas",
                "password_min": "Slaptažodis turi būti bent 6 simbolių ilgio",
                "terms_required": "Turite sutikti su taisyklėmis ir sąlygomis",
                "oldPasswordRequired": "Senas slaptažodis yra privalomas",
                "newPasswordRequired": "Naujas slaptažodis yra privalomas",
                "passwordvalidation": "Slaptažodis turi būti daugiau nei 6 raidės",
                "deckNameRequired":"Būtina nurodyti denio pavadinimą",
                "shortDescriptionRequired":"Būtinas trumpas aprašymas",
                "longDescriptionRequired":"Reikalingas ilgas aprašymas",
                "mainSubjectRequired":"Būtina nurodyti dalyką",
                "regionRequired":"Būtina nurodyti regioną",
                "smallImageUrlRequired":"Reikalingas mažas paveikslėlio URL",
                "longImageUrlRequired":"Reikalingas mažas paveikslėlio URL",
                "statusRequired":"Būtina nurodyti būseną"
            },
            or: 'arba',
            forgotpass: 'Pamiršau slaptažodį',
            zubusstudent: 'Zubrus programėlė mokiniams',
            dowenloadtext: "Prieinama mokiniams per Google Play Store ir App Store.",
            creatematerial: 'Norite kurti mokymosi medžiagą?',
            fordeveloper: 'Zubrus kūrėjams',
            opth1: 'Įveskite saugos kodą, kurį gavote į el. paštą',
            otpdes: 'Siekdami apsaugoti asmeninius vartotojų duomenis, prašome autorizuoti šį prisijungimą.',
            otpcode: 'Išsiųsti naują kodą',
            seconds: 'sek',
            sendOtp: 'Siųsti OTP',
            verifyOtp: 'Patvirtinti OTP',
            loginWithPassword: 'Prisijungti slaptažodžiu',
            loginWithOtp: 'Prisijungti su OTP',
            otpSentSuccess: 'OTP išsiųstas į jūsų el. paštą',
            otpRequestFailed: 'Nepavyko išsiųsti OTP',
            otpVerifyFailed: 'Neteisingas arba pasibaigęs OTP',
            changeEmail: 'Keisti el. paštą',
            loginFailed: 'Prisijungimas nepavyko',
            loginTimeout: 'Per daug nesėkmingų bandymų. Palaukite.',
            loginAttemptsExceeded: 'Per daug nesėkmingų bandymų. Paskyra laikinai užblokuota.',
            remainingAttempts: 'Liko {{count}} bandymų',
            creaeuser: 'Sukurti naują vartotoją',
            months: [
                "Sausis", "Vasaris", "Kovas", "Balandis", "Gegužė", "Birželis",
                "Liepa", "Rugpjūtis", "Rugsėjis", "Spalis", "Lapkritis", "Gruodis"
            ],
            today: "Šiandien",
            yesterday: "Vakar",
            last7Days: "Paskutinės 7 dienos",
            thisMonth: "Šis mėnuo",
            nocard: "Kortelių nerasta",
            Card:"Kortelė",
            attemptsLeft: "Likę bandymai",
            tryAgainIn: "Bandykite dar kartą",
            regulardeck: 'Įprasta kaladė',
            createq: '  Sukurkite klausimus pats.',
            autoai: " Automatinė DI",
            uploadpdf: 'Įkelkite medžiagos failą PDF ir sistema klausimus sukurs automatiškai.',
            newdeck: 'Nauja kaladė',
            createnewuser: 'Sukurti naują vartotoją',
            importcsv: 'Importuoti .xls ar .csv',
            occupiedchar: 'Užimtos "kėdės"',
            ordermore: 'Užsakyti daugiau',
            class_management: {
                title: 'Klasės Valdymas (Class Management)',
                create_class: 'Sukurti Klasę (Create Class)',
                edit_class: 'Redaguoti Klasę (Edit Class)',
                delete_class: 'Ištrinti Klasę (Delete Class)',
                class_name: 'Klasės Pavadinimas (Class Name)',
                class_description: 'Klasės Aprašymas (Class Description)',
                class_grade: 'Klasės Klasė (Class Grade)',
                class_subject: 'Klasės Dalykas (Class Subject)',
                class_status: 'Klasės Būsena (Class Status)',
                active: 'Aktyvi (Active)',
                inactive: 'Neaktyvi (Inactive)',
                delete_confirm: 'Ar tikrai norite ištrinti klasę "{name}"? (Are you sure you want to delete the class "{name}"?)',
                delete_warning: 'Šis veiksmas negali būti atšauktas. (This action cannot be undone.)',
                delete_success: 'Klasė sėkmingai ištrinta (Class deleted successfully)',
                create_success: 'Klasė sėkmingai sukurta (Class created successfully)',
                edit_success: 'Klasė sėkmingai atnaujinta (Class updated successfully)',
                error_occurred: 'Įvyko klaida. Bandykite dar kartą. (An error occurred. Please try again.)',
                bulk_actions: 'Masiniai Veiksmai (Bulk Actions)',
                search_placeholder: 'Ieškoti klasių... (Search classes...)',
                filter_by: 'Filtruoti pagal (Filter by)',
                sort_by: 'Rūšiuoti pagal (Sort by)',
                total_students: 'Iš viso mokinių (Total Students)',
                class_actions: 'Veiksmai (Actions)',
                class_created: 'Sukurta (Created Date)',
                class_teacher: 'Mokytojas (Teacher)',
                class_students: 'Mokiniai (Students)',
                no_classes: 'Klasės nerastos (No classes found)',
                export_csv: 'Eksportuoti į CSV (Export to CSV)',
                import_csv: 'Importuoti iš CSV (Import from CSV)',
                class_statistics: 'Klasės Statistika (Class Statistics)',
                average_performance: 'Vidutinis Rezultatas (Average Performance)',
                completion_rate: 'Užbaigimo Procentas (Completion Rate)',
                last_activity: 'Paskutinis Aktyvumas (Last Activity)'
            },
            parent_management: {
                title: 'Tėvų valdymas',
                add_parent: 'Pridėti tėvą',
                add_success: 'Tėvas sėkmingai pridėtas',
                add_failed: 'Nepavyko pridėti tėvo',
                search_students: 'Ieškoti mokinių pagal vardą arba el. paštą...',
                no_students: 'Mokinių nerasta',
                select_child_required: 'Pasirinkite bent vieną vaiką',
                children_hint: 'Tėvas gali būti susietas su vienu ar keliais mokiniais.',
                import_csv: 'Importuoti CSV',
                search_placeholder: 'Ieškoti tėvų...',
                filter_by_status: 'Filtruoti pagal statusą',
                active: 'Aktyvus',
                inactive: 'Neaktyvus',
                last_login: 'Paskutinis prisijungimas',
                edit_success: 'Tėvas sėkmingai atnaujintas',
                delete_success: 'Tėvas sėkmingai ištrintas',
                phone: 'Telefonas',
                status: 'Statusas',
                children: 'Vaikai',
                registration_date: 'Registracijos data',
                actions: 'Veiksmai',
                no_parents: 'Tėvų nerasta',
                bulk_actions: 'Masiniai Veiksmai',
                export_csv: 'Eksportuoti į CSV',
                parent_details: 'Tėvo Informacija',
                parent_statistics: 'Tėvo Statistika',
                total_children: 'Iš viso Vaikų',
                average_activity: 'Vidutinis Aktyvumas',
                last_activity: 'Paskutinis Aktyvumas'
            },
            teacher_management: {
                title: 'Mokytojų valdymas',
                add_teacher: 'Pridėti mokytoją',
                import_csv: 'Importuoti CSV',
                search_placeholder: 'Ieškoti mokytojų...',
                filter_by_status: 'Filtruoti pagal statusą',
                active: 'Aktyvus',
                inactive: 'Neaktyvus',
                edit_teacher: 'Redaguoti mokytoją',
                edit_success: 'Mokytojas sėkmingai atnaujintas',
                edit_failed: 'Nepavyko atnaujinti mokytojo',
                delete_title: 'Ištrinti mokytoją?',
                delete_success: 'Mokytojas sėkmingai ištrintas',
                delete_failed: 'Nepavyko ištrinti mokytojo',
                subjects: 'Dėstomi dalykai',
                country: 'Šalis',
                roles: 'Rolės',
                teacher_id: 'Mokytojo ID',
                schools: 'Mokyklos',
                last_login: 'Paskutinis prisijungimas',
                status: 'Statusas',
                actions: 'Veiksmai',
                name: 'Vardas',
                email: 'El. paštas',
                phone: 'Telefonas',
                classes: 'Klasės',
                registration_date: 'Registracijos data',
                total_decks: 'Iš viso kaladžių',
                decks_per_class: 'Kaladės per klasę',
                personal_info: 'Asmeninė informacija',
                delete_confirm: 'Ar tikrai norite ištrinti šį mokytoją?',
                error_loading_teacher: 'Klaida įkeliant mokytojo informaciją',
                teacher_not_found: 'Mokytojas nerastas'
            },
            statistics: 'Statistika',
            total_students: 'Iš viso mokinių',
            average_completion: 'Vidutinis kaladžių užbaigimas',
            recent_activity: 'Naujausi veiksmai',
            loading: 'Kraunama...',
            view: 'Peržiūrėti',
            students: 'Mokiniai',
            user_management: {
                title: 'Vartotojų valdymas',
                add_user: 'Pridėti vartotoją',
                import_csv: 'Importuoti CSV',
                search_placeholder: 'Ieškoti vartotojų...',
                filter_by_role: 'Filtruoti pagal rolę',
                user_id: 'Vartotojo ID',
                user_name: 'Vartotojo vardas',
                onetime_key: "Vienkartinis raktas",
                last_name: 'Pavardė',
                email: 'El. paštas',
                role: 'Rolė',
                actions: 'Veiksmai',
                view: 'Peržiūrėti',
                edit: 'Redaguoti',
                remove: 'Pašalinti',
                delete_confirm: 'Ar tikrai norite ištrinti šį vartotoją?',
                delete_success: 'Vartotojas sėkmingai ištrintas',
                edit_success: 'Vartotojas sėkmingai atnaujintas',
                error_loading_user: 'Klaida įkeliant vartotojo informaciją',
                user_not_found: 'Vartotojas nerastas'
            },
            creator_management: {
                title: 'Kūrėjų valdymas',
                add_creator: 'Pridėti kūrėją',
                import_csv: 'Importuoti CSV',
                search_placeholder: 'Ieškoti kūrėjų...',
                filter_by_status: 'Filtruoti pagal statusą',
                creator_id: 'Kūrėjo ID',
                creator_name: 'Kūrėjo vardas',
                email: 'El. paštas',
                status: 'Statusas',
                total_decks: 'Iš viso kaladžių',
                total_students: 'Iš viso mokinių',
                average_rating: 'Vidutinis įvertinimas',
                last_activity: 'Paskutinis aktyvumas',
                actions: 'Veiksmai',
                view: 'Peržiūrėti',
                edit: 'Redaguoti',
                remove: 'Pašalinti',
                active: 'Aktyvus',
                inactive: 'Neaktyvus',
                edit_creator: 'Redaguoti kūrėją',
                delete_title: 'Ištrinti kūrėją?',
                delete_confirm: 'Ar tikrai norite ištrinti šį kūrėją?',
                delete_success: 'Kūrėjas sėkmingai ištrintas',
                delete_failed: 'Nepavyko ištrinti kūrėjo',
                edit_success: 'Kūrėjas sėkmingai atnaujintas',
                edit_failed: 'Nepavyko atnaujinti kūrėjo',
                add_success: 'Kūrėjas sėkmingai pridėtas',
                error_loading: 'Nepavyko įkelti kūrėjų',
                error_loading_creator: 'Klaida įkeliant kūrėjo informaciją',
                creator_not_found: 'Kūrėjas nerastas'
            },
            classDeletedSuccess: "Klasė sėkmingai ištrinta",
            main_answer: 'Pagrindinis atsakymas',
            acceptable_answers: 'Priimtini atsakymai',
            updateclass: 'atnaujinimo klasė',
            editclass: 'redaguoti kursą',
            deckremove: 'Denis sėkmingai pašalintas.',
            areYouSureYouWantToDelete: "Ar tikrai norite ištrinti šią kortelę?",
            areYouSureYouWantToDeleteDeck: "Ar tikrai norite ištrinti šią kaladę?",
            Delete: "Ištrinti",
            Cancel:"Atšaukti",
            importFileAndCreateDeck:"Importuoti failą ir sukurti kaladę",
            manualAdd: "Pridėti kortelę",
            Create:"Sukurti",
            validatingFile: "Tikrinamas failas...",
            pleaseWaitValidating: "Palaukite, kol tikriname jūsų failą",
            pleaseWaitProcessing: "Palaukite, kol apdorojame jūsų kaladės failą",
            processingAndAdding: "Apdorojama ir pridedama...",
            sampleDeckPreview: "Kaladės patikrinimo rezultatai",
            // Toast messages
            fileShouldBeTextDocument: "Failas turi būti teksto dokumentas",
            authenticationRequired: "Reikalingas autentifikavimas. Prašome prisijungti iš naujo.",
            fileValidatedSuccessfully: "Failas sėkmingai patikrintas!",
            validationFailed: "Patikrinimas nepavyko: rasta {errorCount} klaida(ų)",
            validationFailedGeneric: "Patikrinimas nepavyko. Prašome patikrinti failo formatą.",
            invalidFileFormat: "Neteisingas failo formatas. Prašome patikrinti kaladės struktūrą.",
            authenticationFailed: "Autentifikavimas nepavyko. Prašome prisijungti iš naujo.",
            fileTooLarge: "Failas per didelis. Prašome naudoti mažesnį failą.",
            requestTimedOut: "Užklausos laikas baigėsi. Prašome bandyti dar kartą.",
            networkError: "Tinklo klaida. Prašome patikrinti ryšį ir bandyti dar kartą.",
            errorProcessingFile: "Klaida apdorojant failą. Prašome bandyti dar kartą.",
            noValidatedFileContent: "Nėra patikrinto failo turinio",
            deckAddedSuccessfully: "Kaladė sėkmingai pridėta!",
            errorAddingDeck: "Klaida pridedant kaladę. Prašome bandyti dar kartą.",
            deckCreationCancelled: "Kaladės kūrimas atšauktas",
            "first_name": "Vardas",
            "last_name": "Pavardė",
            "preferred_language": "Pasirinktas kalbą",
            "country_code": "Šalies kodas",
            "gender": "Lytis",
            "male": "Vyras",
            "female": "Moteris",
            "unspecified": "Nenustatyta",
            "birth_date": "Gimimo data",
            "nickname": "Naršyklės vardas",
            "edit_student": "Redaguoti mokinį",
            "student_update_success": "Mokinys sėkmingai atnaujintas",
            "creation_date": "Sukurimo data",
            "user_not_found_or_direct_access": "Vartotojo duomenys nerasti arba puslapis pasiektas tiesiogiai.",
            "back_to_user_list": "Grįžti į vartotojų sąrašą",
            "user_details": "Vartotojo duomenys",
            "username": "Vartotojo vardas",
            "roles": "Rolės",
            "student_deleted_successfully": "Mokinys sėkmingai ištrintas!",
            "delete_student_title": "Ištrinti mokinį?",
            "delete_student_message": "Ar tikrai norite visam laikui ištrinti šį mokinį? Šio veiksmo anuliuoti negalima.",
            "add_student_title": "Pridėti naują mokinį",
            "student_added_successfully": "Mokinys sėkmingai pridėtas!",
            "one_time_key": "Vienkartinis raktas",
            "key_copied": "Raktas nukopijuotas į iškarpinę!",
            "copy_key": "Kopijuoti raktą",
            quiz: {
                title: "Viktorina",
                publicDecks: "Viešos kaladės",
                library: "ZUBROTEKA",
                chooseDeckTitle: "Pasirink savo kaladę",
                decksForDisciplines: "kaladės · įvairioms disciplinoms ir klasėms.",
                quickFilter: {
                    history: "Istorija",
                    biology: "Biologija",
                    geography: "Geografija",
                    mathematics: "Matematika",
                    languages: "Kalbos",
                },
                chooseDeck: "Pasirinkite kaladę ir pradėkite mokytis",
                deckNotFound: "Kaladė nerasta",
                playQuiz: "Žaisti viktoriną",
                welcome: "Sveiki atvykę į Zubrus viktoriną!",
                enterCodeToJoin: "Įveskite viktorinos kodą, kad prisijungtumėte",
                codePlaceholder: "Įveskite kodą...",
                codeRequired: "Įveskite viktorinos kodą",
                joinQuiz: "Prisijungti prie viktorinos",
                join: "Prisijungti",
                askTeacherForCode: "Paprašykite mokytojo viktorinos kodo",
                quizNotFound: "Viktorina nerasta",
                checkCodeAndTryAgain: "Patikrinkite kodą ir bandykite dar kartą",
                backToHome: "Grįžti į pradžią",
                enterYourDetails: "Įveskite savo duomenis",
                yourName: "Jūsų vardas",
                namePlaceholder: "Įveskite savo vardą...",
                nameRequired: "Įveskite savo vardą",
                nameMinLength: "Vardas turi būti bent 2 simbolių",
                iAmA: "Aš esu",
                student: "Mokinys",
                teacher: "Mokytojas",
                startQuiz: "Pradėti viktoriną",
                differentCode: "Naudoti kitą kodą",
                questions: "klausimai",
                minutes: "min",
                score: "Rezultatas",
                correctAnswer: "Teisingai!",
                wrongAnswer: "Neteisingai!",
                timeUp: "Laikas baigėsi!",
                nextQuestion: "Kitas klausimas",
                finishQuiz: "Baigti viktoriną",
                questionOf: "{{current}} / {{total}}",
                seeResults: "Žiūrėti rezultatus",
                noQuestions: "Nėra klausimų",
                quizComplete: "Viktorina baigta!",
                greatJob: "Puikiai padirbėta",
                correctAnswers: "Teisingi",
                wrongAnswers: "Neteisingi",
                totalScore: "Rezultatas",
                playAgain: "Žaisti dar kartą",
                newQuiz: "Prisijungti prie kitos viktorinos",
                selectCardsInstruction: "Pasirinkite korteles viktorinai (mažiausiai 1)",
                selectAll: "Pasirinkti visas",
                deselectAll: "Atžymėti visas",
                cardsSelected: "kortelės pasirinktos",
                generateQuiz: "Generuoti viktoriną",
                quizLobby: "Laukiame viktorinos pradžios",
                scanToJoin: "Nuskaitykite QR kodą, kad prisijungtumėte",
                copy: "Kopijuoti",
                studentsJoined: "Prisijungę mokiniai",
                waitingForStudents: "Laukiama mokinių...",
                waitingForTeacher: "Laukiama, kol mokytojas pradės viktoriną...",
                studentsWaiting: "mokiniai laukia",
                studentsAnswered: "Mokiniai atsakė",
                quizResults: "Viktorinos rezultatai",
                sessionId: "Sesija",
                totalStudents: "Iš viso mokinių",
                averageScore: "Vidutinis rezultatas",
                bestScore: "Geriausias rezultatas",
                leaderboard: "Lyderių lentelė",
                name: "Vardas",
                time: "Laikas",
                exportResults: "Eksportuoti rezultatus",
                exportComingSoon: "Eksportavimo funkcija netrukus!",
                tapToFlip: "Paspauskite, kad pamatytumėte atsakymą",
                tapToSeeQuestion: "Paspauskite, kad pamatytumėte klausimą",
                getReady: "Pasiruošk",
                joinCode: "Prisijungimo kodas",
                waitingToStart: "Laukiama, kol prasidės viktorina",
                waitingForQuestion: "Laukiama kito klausimo...",
                waitingForNext: "Laukiama kito klausimo...",
                loadingQuestion: "Įkeliamas klausimas...",
                timesUp: "Laikas baigėsi!",
                answerSubmitted: "Atsakymas pateiktas!",
                submitAnswer: "Pateikti atsakymą",
                typeYourAnswer: "Įveskite savo atsakymą...",
                secondsPerQuestion: "Sekundės / klausimui",
                creating: "Kuriama...",
                joining: "Jungiamasi...",
                joinFailed: "Nepavyko prisijungti. Patikrinkite kodą ir bandykite dar kartą.",
                sessionNotFound: "Viktorinos sesija nerasta",
                sessionNotFoundHint: "Prašome sukurti viktoriną iš naujo.",
                noParticipants: "Nėra dalyvių",
                seeTeacherLeaderboard: "Mokytojas mato visą lyderių lentelę.",
            },
            Learning: "Mokymasis",
            Zubrinti: "Zubrinti",
            previous: "Ankstesnis",
            "csv_import": {
                "title": "Importuoti mokinius iš CSV",
                "download_sample_title": "Atsisiųsti CSV pavyzdį",
                "download_sample_description": "Atsisiųskite CSV pavyzdžio failą, kad pamatytumėte reikalingą formatą mokinių importavimui.",
                "download_sample_button": "Atsisiųsti pavyzdį",
                "upload_title": "Įkelti CSV failą",
                "choose_file": "Pasirinkti failą",
                "selected_file": "Pasirinktas: {filename}",
                "import_progress_title": "Importavimo progresas",
                "processing_text": "Apdorojama: {current} iš {total} mokinių",
                "successful_count": "✓ {count} sėkmingai",
                "failed_count": "✗ {count} nepavyko",
                "errors_found": "Rastos klaidos:",
                "processing": "Apdorojama...",
                "importing": "Importuojama...",
                "import_button": "Importuoti",
                "please_select_valid_csv": "Prašome pasirinkti tinkamą CSV failą",
                "please_select_csv": "Prašome pasirinkti CSV failą",
                "csv_parsing_error": "CSV apdorojimo klaida: {error}",
                "csv_no_valid_data": "CSV faile nėra tinkamų duomenų eilučių",
                "import_success": "Sėkmingai importuoti {count} mokiniai",
                "import_completed": "Importavimas baigtas: {success} sėkmingai, {failed} nepavyko",
                "error_processing_csv": "Klaida apdorojant CSV failą",
                "validation_first_name_required": "Vardas yra privalomas",
                "validation_last_name_required": "Pavardė yra privaloma",
                "validation_email_required": "El. paštas yra privalomas",
                "validation_email_invalid": "Neteisingas el. pašto formatas",
                "validation_gender_invalid": "Lytis turi būti VYRAS, MOTERIS arba NENUSTATYTA",
                "validation_duplicate_email": "Dublikuotas el. paštas \"{email}\" rastas CSV faile",
                "error_email_exists": "El. paštas \"{email}\" jau egzistuoja sistemoje",
                "error_invalid_data": "Pateikti netinkami mokinio duomenys",
                "error_validation_failed": "Patikrinimas nepavyko - patikrinkite privalomus laukus",
                "error_server_error": "Serverio klaida - bandykite dar kartą vėliau",
                "error_network": "Tinklo ryšio klaida - patikrinkite interneto ryšį",
                "error_timeout": "Užklausos laikas baigėsi - serveris per ilgai atsako",
                "error_failed_create": "Nepavyko sukurti mokinio",
                "error_csv_empty": "CSV failas tuščias",
                "error_missing_headers": "Trūksta reikalingų antraščių: {headers}"
            }
        },
    },
};

resources.es = {
    translation: {
        login: "Iniciar sesión",
        register: 'Registrarse',
        uniquekey: 'Clave única',
        keyinfo: '¿Qué es esto?',
        name: 'Nombre',
        lastname: 'Apellido',
        keydes: 'Este es un código de un solo uso que recibirá del personal de su escuela. Le permitirá crear una cuenta.',
        firstTime: "¿Primera vez?",
        signup: "Registrarse",
        copyright: '© 2025 Zubrus. Todos los derechos reservados.',
        email: 'Correo electrónico',
        password: 'Contraseña',
        confirmmsg: 'Enviaremos un correo de confirmación a su dirección de correo electrónico.',
        agree: 'Acepto',
        rules: 'Los términos',
        and: 'y',
        policy: 'Política de privacidad',
        confirmemail: 'Confirme su dirección de correo electrónico',
        emailmsg: 'Hemos enviado una confirmación a su dirección de correo electrónico {{email}}. La confirmación es necesaria para que, si olvida su contraseña, sea fácil recuperarla.',
        back: "Ir a Zubrus",
        profile: 'Perfil',
        creator: '¿Quiere convertirse en creador?',
        creatordes: 'Cree sus propias barajas y materiales.',
        want: 'Quiero',
        Personaldata: 'Datos personales',
        changepassword: 'Cambiar contraseña',
        changelan: 'Cambiar idioma',
        logout: 'Cerrar sesión',
        becomecreator: 'Quiero convertirme en creador.',
        becomecreatorh1: '¿Quiere crear su propio material Zubrus?',
        becomecreatorh2: '¿Le gustaría que no solo sus estudiantes sino también otros niños lo logren?',
        becomecreatorh3: '¿O tal vez le gustaría trabajar con Zubrus y ganar dinero?',
        becomecreatorh4: '¡Regístrese simplemente haciendo clic en el botón y nos pondremos en contacto con usted!',
        signup2: '¡Registrarse!',
        registered: '¡Se ha registrado!',
        newsoon: 'Pronto volveremos con noticias.',
        myclasses: 'Mis clases',
        createclass: 'Crear una clase',
        picture: 'Imagen',
        student: 'estudiantes',
        teacher: 'profesores',
        createfirstclass: 'Cree su primera clase.',
        class: 'Clases',
        zubroteka: 'Baraja',
        workshop: 'Talleres',
        september: 'Septiembre 2024',
        menuItems: {
            classes: 'Clases',
            zubroteka: 'Baraja',
            workshops: 'Talleres',
            Contentcreator: 'Creador de contenido',
            admin: 'Administrador'
        },
        adminmenu: {
            userlist: 'Lista de usuarios',
            classlist: 'Lista de clases',
            parentslist: 'Lista de padres',
            teacherlist: 'Lista de profesores',
            creatorList: 'Lista de creadores',
            payments: 'Pagos',
            service: 'Servicio'
        },
        tabs: {
            overview: 'Resumen',
            material: 'Material',
            people: 'Personas'
        },
        filter: {
            popularity: 'Por popularidad',
            newest: 'Por más nuevo',
            recently_watched: 'Por visto recientemente'
        },
        average: 'Promedio',
        activity: 'actividad',
        result: 'resultado',
        mostactive: 'Más activos',
        passive: 'Los más pasivos',
        best: 'Los mejores',
        worst: 'Los peores',
        deckspopularity: 'Barajas por popularidad',
        deckscore: 'Barajas por puntuación promedio',
        edit: 'Editar',
        add: 'Agregar',
        castle: 'Castillo',
        folder: 'Carpeta',
        editmode: 'Modo de edición',
        adjust: 'Mueva y reorganice elementos, elimine bloques innecesarios.',
        allsee: 'Todos pueden ver',
        nosee: 'Nadie ve',
        Optional: 'Opcional',
        whosee: 'Quién ve',
        uncheck: 'Desmarcar todo',
        question: 'Pregunta',
        questions: 'Preguntas',
        about: 'Acerca de',
        Statistics: 'Estadísticas',
        general: 'General',
        all: 'Todo',
        people: 'Personas',
        search: 'Buscar',
        Performance: 'Rendimiento',
        remove: 'Eliminar',
        fromclass: '¿de la clase?',
        dltmsg: 'Una persona eliminada ya no podrá ver el contenido de su clase y sus estadísticas desaparecerán.',
        cancel: 'Cancelar',
        selectSchool: 'Seleccionar escuela',
        noSchoolsFound: 'No se encontraron escuelas',
        continue: 'Continuar',
        pleaseSelectSchool: 'Seleccione una escuela para continuar',
        failedToFetchSchools: 'Error al obtener información de la escuela',
        schoolSelectionRequired: 'La selección de escuela es obligatoria. Contacte a su administrador.',
        noSchoolsMessage: 'No tiene acceso a ninguna escuela en este momento.',
        singleSchoolAutoSelected: 'Esta escuela ha sido seleccionada automáticamente.',
        catalog: 'Catálogo',
        Favorites: 'Favoritos',
        useit: 'Ya lo uso.',
        Alldisciplines: 'Todas las disciplinas',
        allages: 'Para todas las edades',
        Allauthors: 'Todos los autores',
        Bypopularity: 'Por popularidad',
        detail: 'En detalle',
        answer: 'Respuesta',
        answers: 'Respuestas',
        Prompter: 'Sugerencia',
        feedback: 'Comentarios al desarrollador',
        answerType: 'Tipo de respuesta',
        answerTypeInput: 'Entrada',
        answerTypeMemory: 'Memoria',
        answerTypeTest: 'Test',
        complexity: 'Complejidad',
        complexityVeryEasy: '1 Muy fácil',
        complexityEasy: '2 Fácil',
        complexityMedium: '3 Medio',
        complexityHard: '4 Difícil',
        complexityVeryHard: '5 Muy difícil',
        cardName: 'Nombre de la tarjeta',
        addCard: 'Agregar tarjeta',
        editCard: 'Editar tarjeta',
        editDeck: 'Editar baraja',
        addAnswer: 'Agregar respuesta',
        newQuestion: 'Nueva pregunta',
        addHint: 'Agregar sugerencia',
        characters: 'caracteres',
        clickToAddImage: 'Haga clic para agregar imagen',
        addMore: 'Agregar más',
        addImage: 'Agregar imagen',
        addAudio: 'Agregar audio',
        addText: 'Agregar texto',
        move: 'Mover',
        deckUpdatedSuccess: 'Tarjeta actualizada exitosamente',
        deckCardAddedSuccess: 'Tarjeta agregada exitosamente',
        enterText: 'Ingrese texto...',
        inputHint: 'Sugerencia de entrada',
        inputHintPlaceholder: 'Sugerencia para responder...',
        addInputHint: 'Agregar sugerencia de entrada',
        clickToAdd: 'Haga clic para agregar',
        uploadImages: 'Subir imágenes',
        uploadImage: 'Subir imagen',
        clickToUploadImages: 'Haga clic para subir imágenes',
        uploading: 'Subiendo...',
        uploadImageCount: 'Subir {{count}} imagen(es)',
        uploadFiles: 'Subir archivos',
        uploadImagesAndAudio: 'Imágenes y audio',
        clickToUploadFiles: 'Haga clic para subir archivos',
        supportsImagesAndAudio: 'Compatible con imágenes y archivos de audio',
        selectedFiles: 'Archivos seleccionados',
        uploadFileCount: 'Subir {{count}} archivo(s)',
        Send: 'Enviar',
        assignToDeck: 'Asignar a baraja',
        assignCardToAnotherDeck: 'Asignar tarjeta',
        searchDecks: 'Buscar barajas...',
        searchCards: 'Buscar tarjetas...',
        selectAtLeastOneDeck: 'Seleccione al menos una baraja',
        cardAssignedSuccess: 'Tarjeta asignada a {{count}} baraja(s) exitosamente',
        cardAssignedError: 'Error al asignar a {{count}} baraja(s)',
        cardsAssignedSuccess: '{{count}} tarjeta(s) asignada(s) exitosamente',
        selected: 'seleccionado',
        selectDecks: 'Seleccionar barajas para asignar',
        selectACard: 'Seleccionar una tarjeta',
        selectCardToAssign: 'Seleccionar tarjeta para asignar',
        selectCardsToAssign: 'Seleccionar tarjetas para asignar',
        selectCards: 'Seleccionar tarjetas',
        selectTargetDecks: 'Seleccionar barajas destino',
        step1of2: 'Paso 1 de 2',
        noCardsFound: 'No se encontraron tarjetas',
        noCardsInDeck: 'No hay tarjetas en esta baraja',
        noCardsToAssign: 'No hay tarjetas disponibles para asignar. Agregue tarjetas primero.',
        select: 'Seleccionar',
        selectAll: 'Seleccionar todo',
        deselectAll: 'Deseleccionar todo',
        cardSelected: 'tarjeta seleccionada',
        cardsSelected: 'tarjetas seleccionadas',
        decksSelected: 'baraja(s) seleccionada(s)',
        selectDeck: 'Seleccionar baraja',
        importCard: 'Importar tarjeta',
        cardView: 'Tarjetas',
        listView: 'Lista',
        moveCardUp: 'Mover arriba',
        moveCardDown: 'Mover abajo',
        dragToReorder: 'Arrastra para cambiar el orden',
        savingOrder: 'Guardando orden...',
        cardOrderSaved: 'Orden de tarjetas guardado',
        cardOrderFailed: 'No se pudo guardar el orden',
        cardOrderLoginRequired: 'Inicia sesión para guardar el orden',
        myDecks: 'Mis barajas',
        allDecks: 'Todas las barajas',
        importCardsFromDeck: 'Importar tarjetas de baraja',
        selectCardsToImport: 'Seleccionar tarjetas para importar',
        selectSourceDeck: 'Elegir una baraja para importar tarjetas',
        chooseSourceDeck: 'Elegir baraja fuente',
        selectCardsToImportHint: 'Seleccionar tarjetas para importar',
        importing: 'Importando...',
        import: 'Importar',
        cardsImportedSuccess: 'Tarjetas importadas exitosamente',
        deckDeletedSuccess: 'Tarjeta eliminada exitosamente',
        deckIdMissing: 'ID de baraja no encontrado',
        fixValidationErrors: 'Por favor corrija los errores de validación antes de importar',
        multipleChoice: 'Opción múltiple',
        answerOption: 'Opción de respuesta',
        markAsCorrect: 'Marcar como correcto',
        markAsWrong: 'Marcar como incorrecto',
        correctAnswer: '✓ Respuesta correcta',
        wrongAnswer: 'Respuesta incorrecta',
        addAnswerOption: 'Agregar opción de respuesta',
        testAnswerInfo: 'Haga clic en la letra/marca para marcar la respuesta correcta. Se requieren al menos 2 opciones, 1 debe ser correcta.',
        correct: 'correcto',
        total: 'total',
        mark: 'Marca',
        markPlaceholder: 'ej. Examen, Quiz',
        markHelperText: 'Se muestra en la parte superior de la tarjeta',
        mainSubjectPlaceholder: 'ej. Matemáticas, Ciencias',
        subject: 'Materia',
        gradeLabel: 'Grado',
        schoolGrades: 'Grados escolares',
        schoolGradesPlaceholder: 'ej. 5, 6-8, 10-12',
        schoolGradesHelperText: 'Opcional. Especifique los grados objetivo.',
        region: 'Región',
        selectRegion: 'Seleccionar región',
        next: 'Siguiente',
        assign: 'Asignar',
        assigning: 'Asignando...',
        noDecksFound: 'No se encontraron barajas',
        noOtherDecks: 'No hay otras barajas disponibles',
        cards: 'tarjetas',
        deckName: 'Nombre de baraja',
        status: 'Estado',
        authorName: 'Nombre del autor',
        createdBy: 'Creado por',
        language: 'Idioma',
        countries: 'Países',
        creationDate: 'Fecha de creación',
        published: 'PUBLICADO',
        deckworkshop: 'Taller de barajas',
        creatdeck: 'Crear una baraja',
        validatingFile: 'Validando archivo...',
        pleaseWaitProcessing: 'Por favor espere mientras procesamos su archivo',
        processingAndAdding: 'Importando...',
        addDeck: 'Importar',
        verifyAgain: 'Verificar de nuevo',
        askAI: 'Preguntar a IA',
        askingAI: 'Preguntando a IA...',
        DeckInformation: 'Información de baraja',
        DeckSummary: 'Resumen de baraja',
        DeckWarnings: 'Advertencias de baraja',
        DeckErrors: 'Errores de baraja',
        Draft: 'Borrador',
        Published: 'Publicado',
        Publish: 'Publicar',
        Private: 'Privado',
        withoutname: 'Baraja sin nombre',
        Settings: 'Configuración',
        Test: 'Prueba',
        json: 'Importar preguntas',
        importQuestions: 'Importar preguntas',
        chooseFile: 'Elegir archivos',
        noFileChosen: 'Ningún archivo seleccionado',
        acceptedTxtOnly: 'Acepta archivos .txt en formato simplificado',
        uploadFromFile: 'Subir desde un archivo',
        pasteSimplifiedText: 'Pega el formato de texto simplificado',
        pasteSimplifiedTextPlaceholder: 'Pega tus preguntas en formato de texto simplificado aquí...',
        pasteOrUploadContent: 'Pega contenido o sube un archivo primero',
        validating: 'Validando...',
        mychild: 'Mis hijos',
        challenge: 'Desafíos diarios',
        personaldata: 'Datos personales',
        save: 'Guardar',
        emailconfimmsg: 'Después de cambiar su correo, deberá confirmarlo. Le enviaremos un correo de confirmación.',
        current: 'Actual',
        new: 'Nuevo',
        whatnext: '¿Qué sigue?',
        overviewh2: 'Agregar una baraja de preguntas de Zubroteka',
        watch: 'Ver el aprendizaje',
        hide: 'Ocultar',
        whatmaterial: '¿Qué es ese material?',
        deck: 'Baraja',
        Edit: 'Editar',
        update: 'Actualizar',
        shortDescription: 'Descripción corta',
        longDescription: 'Descripción larga',
        mainSubject: 'Materia',
        deckCover: 'Portada de baraja',
        smallInParentheses: '(pequeña)',
        largeInParentheses: '(grande)',
        clickToUploadSmallImage: 'Haga clic para subir imagen pequeña',
        clickToUploadLargeImage: 'Haga clic para subir imagen grande',
        clickToChange: 'Haga clic para cambiar',
        selectStatus: 'Seleccionar estado',
        Hidden: 'Oculto',
        'Work In Progress': 'En progreso',
        Deleted: 'Eliminado',
        mqa2: 'Seleccione barajas de preguntas de Zubroteka o de barajas que ya usa. Las barajas seleccionadas serán visibles para todos los estudiantes.',
        mqa3: 'Puede agrupar barajas en carpetas en cualquier orden. También puede cambiar el orden de los elementos.',
        mq4: 'Acceso restringido a carpeta',
        mqa4: 'Puede agrupar barajas en carpetas en cualquier orden. También puede cambiar el orden de los elementos.',
        whatpeople: 'Personas - ¿qué es?',
        pq1: 'Invite estudiantes de la lista. El material aparecerá en su aplicación automáticamente.',
        pq2: 'Puede invitar más profesores para ayudarle a recopilar materiales o invitar personas.',
        Invitepeople: 'Invitar personas',
        oa2: 'Forme una clase de profesores y estudiantes',
        oq3: 'Ver el aprendizaje',
        oa3: 'Monitorear estadísticas generales e individuales',
        loginmsg: 'sesión iniciada exitosamente',
        signupmsg: 'usuario creado exitosamente',
        logoutmsg: 'sesión cerrada exitosamente',
        passwordChanged: 'Contraseña cambiada exitosamente',
        emailupdated: 'Correo actualizado exitosamente',
        user: 'Usuario',
        validation: {
            questionrequired: 'La pregunta es obligatoria',
            answerrequired: 'La respuesta es obligatoria',
            cardNameRequired: 'El nombre de la tarjeta es obligatorio',
            atLeastOneAnswer: 'Se requiere al menos una respuesta',
            testMinimumOptions: 'Se requieren al menos 2 opciones para opción múltiple',
            testNeedsCorrect: 'Marque al menos una respuesta como correcta',
            userrequired: 'El nombre de usuario es obligatorio',
            usercharacter: 'El nombre de usuario debe tener al menos 4 caracteres',
            passwordrequired: 'La contraseña es obligatoria',
            uniquekey_required: 'La clave única es obligatoria',
            uniquekey_invalid: 'La clave única debe seguir el formato 000-000-000',
            name_required: 'El nombre es obligatorio',
            lastname_required: 'El apellido es obligatorio',
            email_required: 'El correo electrónico es obligatorio',
            email_invalid: 'Formato de correo inválido',
            password_required: 'La contraseña es obligatoria',
            password_min: 'La contraseña debe tener al menos 8 caracteres',
            terms_required: 'Debe aceptar los términos y condiciones',
            oldPasswordRequired: 'La contraseña actual es obligatoria',
            newPasswordRequired: 'La nueva contraseña es obligatoria',
            passwordvalidation: 'La contraseña debe tener más de 6 letras',
            deckNameRequired: 'El nombre de la baraja es obligatorio',
            shortDescriptionRequired: 'La descripción corta es obligatoria',
            longDescriptionRequired: 'La descripción larga es obligatoria',
            mainSubjectRequired: 'La materia es obligatoria',
            regionRequired: 'La región es obligatoria',
            smallImageUrlRequired: 'La URL de imagen pequeña es obligatoria',
            longImageUrlRequired: 'La URL de imagen grande es obligatoria',
            statusRequired: 'El estado es obligatorio'
        },
        or: 'o',
        forgotpass: 'Olvidé mi contraseña.',
        zubusstudent: 'Aplicación Zubrus para estudiantes',
        dowenloadtext: 'Disponible para estudiantes en Google Play Store y App Store.',
        creatematerial: '¿Quiere crear materiales de aprendizaje?',
        fordeveloper: 'Zubrus para desarrolladores',
        opth1: 'Ingrese el código de seguridad que recibió en su correo.',
        otpdes: 'Para proteger los datos personales, autorice este inicio de sesión.',
        otpcode: 'Enviar nuevo código',
        seconds: 'segundos',
        sendOtp: 'Enviar OTP',
        verifyOtp: 'Verificar OTP',
        loginWithPassword: 'Iniciar sesión con contraseña',
        loginWithOtp: 'Iniciar sesión con OTP',
        otpSentSuccess: 'OTP enviado a su correo',
        otpRequestFailed: 'No se pudo enviar el OTP',
        otpVerifyFailed: 'OTP inválido o expirado',
        changeEmail: 'Cambiar correo',
        loginFailed: 'Error al iniciar sesión',
        loginTimeout: 'Demasiados intentos fallidos. Espere.',
        loginAttemptsExceeded: 'Demasiados intentos fallidos. Cuenta bloqueada temporalmente.',
        remainingAttempts: '{{count}} intentos restantes',
        creaeuser: 'Crear nuevo usuario',
        months: [
            'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
            'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ],
        today: 'Hoy',
        yesterday: 'Ayer',
        last7Days: 'Últimos 7 días',
        thisMonth: 'Este mes',
        nocard: 'No se encontraron tarjetas',
        Card: 'Tarjeta',
        attemptsLeft: 'Intentos restantes',
        tryAgainIn: 'Intente de nuevo en',
        regulardeck: 'Baraja regular',
        createq: 'Cree sus propias preguntas.',
        autoai: 'IA automática',
        uploadpdf: 'Suba el archivo de material en PDF y el sistema generará preguntas automáticamente.',
        newdeck: 'Nueva baraja',
        ALL: 'TODOS',
        PUBLISHED: 'PUBLICADO',
        HIDDEN: 'OCULTO',
        PRIVATE: 'PRIVADO',
        WORK_IN_PROGRESS: 'EN_PROGRESO',
        createnewuser: 'Crear nuevo usuario',
        importcsv: 'Importar .xls o .csv',
        occupiedchar: 'Asientos ocupados',
        ordermore: 'Ordenar más',
        classDeletedSuccess: 'Clase eliminada exitosamente',
        main_answer: 'Respuesta principal',
        acceptable_answers: 'Respuestas aceptables',
        updateclass: 'Actualizar clase',
        editclass: 'Editar clase',
        deckremove: 'Baraja eliminada exitosamente.',
        areYouSureYouWantToDelete: '¿Está seguro de que desea eliminar esta tarjeta?',
        areYouSureYouWantToDeleteDeck: '¿Está seguro de que desea eliminar esta baraja?',
        Delete: 'Eliminar',
        Cancel: 'Cancelar',
        importFileAndCreateDeck: 'Importar archivo y crear baraja',
        manualAdd: 'Agregar manualmente',
        Create: 'Crear',
        validatingFile: 'Validando archivo...',
        pleaseWaitProcessing: 'Por favor espere mientras procesamos su archivo',
        sampleDeckPreview: 'Vista previa de baraja de muestra',
        fileShouldBeTextDocument: 'El archivo debe ser un documento de texto',
        authenticationRequired: 'Se requiere autenticación. Inicie sesión de nuevo.',
        fileValidatedSuccessfully: '¡Archivo validado exitosamente!',
        validationFailed: 'Validación fallida: {errorCount} error(es) encontrado(s)',
        validationFailedGeneric: 'Validación fallida. Verifique el formato del archivo.',
        invalidFileFormat: 'Formato de archivo inválido. Verifique la estructura de la baraja.',
        authenticationFailed: 'Autenticación fallida. Inicie sesión de nuevo.',
        fileTooLarge: 'Archivo demasiado grande. Use un archivo más pequeño.',
        requestTimedOut: 'Tiempo de solicitud agotado. Intente de nuevo.',
        networkError: 'Error de red. Verifique su conexión e intente de nuevo.',
        errorProcessingFile: 'Error al procesar el archivo. Intente de nuevo.',
        noValidatedFileContent: 'No hay contenido de archivo validado disponible',
        deckAddedSuccessfully: '¡Baraja agregada exitosamente!',
        errorAddingDeck: 'Error al agregar baraja. Intente de nuevo.',
        deckCreationCancelled: 'Creación de baraja cancelada',
        first_name: 'Nombre',
        last_name: 'Apellido',
        preferred_language: 'Idioma preferido',
        country_code: 'Código de país',
        gender: 'Género',
        male: 'Masculino',
        female: 'Femenino',
        unspecified: 'No especificado',
        birth_date: 'Fecha de nacimiento',
        nickname: 'Apodo',
        edit_student: 'Editar estudiante',
        student_update_success: 'Estudiante actualizado exitosamente',
        creation_date: 'Fecha de creación',
        user_not_found_or_direct_access: 'Datos de usuario no encontrados o página accedida directamente.',
        back_to_user_list: 'Volver a la lista de usuarios',
        user_details: 'Detalles del usuario',
        username: 'Nombre de usuario',
        roles: 'Roles',
        student_deleted_successfully: '¡Estudiante eliminado exitosamente!',
        delete_student_title: '¿Eliminar estudiante?',
        delete_student_message: '¿Está seguro de que desea eliminar permanentemente este estudiante? Esta acción no se puede deshacer.',
        add_student_title: 'Agregar nuevo estudiante',
        student_added_successfully: '¡Estudiante agregado exitosamente!',
        one_time_key: 'Clave de un solo uso',
        key_copied: '¡Clave copiada al portapapeles!',
        copy_key: 'Copiar clave',
        statistics: 'Estadísticas',
        total_students: 'Total de estudiantes',
        average_completion: 'Completación promedio de baraja',
        recent_activity: 'Actividad reciente',
        loading: 'Cargando...',
        view: 'Ver',
        students: 'Estudiantes',
        deckUpdatedSuccess: 'Baraja actualizada exitosamente',
        deckCreatedSuccess: 'Baraja creada exitosamente',
        quiz: {
            title: "Quiz",
            publicDecks: "Barajas públicas",
            library: "BIBLIOTECA",
            chooseDeckTitle: "Elige tu baraja",
            decksForDisciplines: "barajas · para diversas disciplinas y clases.",
            quickFilter: {
                history: "Historia",
                biology: "Biología",
                geography: "Geografía",
                mathematics: "Matemáticas",
                languages: "Idiomas",
            },
            chooseDeck: "Elige una baraja para empezar a aprender",
            deckNotFound: "Baraja no encontrada",
            playQuiz: "Jugar Quiz",
            welcome: "¡Bienvenido al Quiz de Zubrus!",
            enterCodeToJoin: "Ingrese el código del quiz para unirse",
            codePlaceholder: "Ingrese el código...",
            codeRequired: "Ingrese un código de quiz",
            joinQuiz: "Unirse al Quiz",
            join: "Unirse",
            askTeacherForCode: "Pida el código del quiz a su profesor",
            quizNotFound: "Quiz no encontrado",
            checkCodeAndTryAgain: "Verifique su código e intente de nuevo",
            backToHome: "Volver al inicio",
            enterYourDetails: "Ingrese sus datos",
            yourName: "Su nombre",
            namePlaceholder: "Ingrese su nombre...",
            nameRequired: "Ingrese su nombre",
            nameMinLength: "El nombre debe tener al menos 2 caracteres",
            iAmA: "Soy un",
            student: "Estudiante",
            teacher: "Profesor",
            startQuiz: "Comenzar Quiz",
            differentCode: "Usar otro código",
            questions: "preguntas",
            minutes: "min",
            score: "Puntuación",
            correctAnswer: "¡Correcto!",
            wrongAnswer: "¡Incorrecto!",
            timeUp: "¡Se acabó el tiempo!",
            nextQuestion: "Siguiente pregunta",
            finishQuiz: "Finalizar Quiz",
            questionOf: "{{current}} / {{total}}",
            seeResults: "Ver resultados",
            noQuestions: "No hay preguntas disponibles",
            quizComplete: "¡Quiz completado!",
            greatJob: "Buen trabajo",
            correctAnswers: "Correctas",
            wrongAnswers: "Incorrectas",
            totalScore: "Puntuación",
            playAgain: "Jugar de nuevo",
            newQuiz: "Unirse a otro Quiz",
            selectCardsInstruction: "Seleccione tarjetas para el quiz (mínimo 1)",
            selectAll: "Seleccionar todas",
            deselectAll: "Deseleccionar todas",
            cardsSelected: "tarjetas seleccionadas",
            generateQuiz: "Generar Quiz",
            quizLobby: "Sala de espera del Quiz",
            scanToJoin: "Escanee el código QR para unirse",
            copy: "Copiar",
            studentsJoined: "Estudiantes unidos",
            waitingForStudents: "Esperando estudiantes...",
            waitingForTeacher: "Esperando que el profesor inicie el quiz...",
            studentsWaiting: "estudiantes esperando",
            studentsAnswered: "Estudiantes respondieron",
            quizResults: "Resultados del Quiz",
            sessionId: "Sesión",
            totalStudents: "Total de estudiantes",
            averageScore: "Puntuación promedio",
            bestScore: "Mejor puntuación",
            leaderboard: "Tabla de posiciones",
            name: "Nombre",
            time: "Tiempo",
            exportResults: "Exportar resultados",
            exportComingSoon: "¡Función de exportación próximamente!",
            tapToFlip: "Toca para ver la respuesta",
            tapToSeeQuestion: "Toca para ver la pregunta",
            getReady: "Prepárate",
            joinCode: "Código de acceso",
            waitingToStart: "Esperando a que comience el quiz",
            waitingForQuestion: "Esperando la siguiente pregunta...",
            waitingForNext: "Esperando la siguiente pregunta...",
            loadingQuestion: "Cargando pregunta...",
            timesUp: "¡Se acabó el tiempo!",
            answerSubmitted: "¡Respuesta enviada!",
            submitAnswer: "Enviar respuesta",
            typeYourAnswer: "Escribe tu respuesta...",
            secondsPerQuestion: "Segundos / pregunta",
            creating: "Creando...",
            joining: "Uniéndose...",
            joinFailed: "No se pudo unir al quiz. Verifica el código e inténtalo de nuevo.",
            sessionNotFound: "Sesión de quiz no encontrada",
            sessionNotFoundHint: "Por favor, crea el quiz de nuevo.",
            noParticipants: "Sin participantes",
            seeTeacherLeaderboard: "Tu profesor puede ver la tabla de posiciones completa.",
        },
        Learning: "Aprendizaje",
        Zubrinti: "Zubrinti",
        previous: "Anterior",
    }
};

i18n.use(initReactI18next).init({
    resources,
    lng: currentLanguage || "lt",
    interpolation: {
        escapeValue: false,
    },
});
store.subscribe(() => {
    const newLanguage = store?.getState().profileData?.language;
    i18n.changeLanguage(newLanguage); // Change language dynamically when Redux state updates
});


export default i18n;
